var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburgerIcon = function SvgHamburgerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414e5f",
    "data-name": "Group 3928",
    transform: "translate(-15 -113)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 2,
    "data-name": "Rectangle 2335",
    rx: 1,
    transform: "translate(15 113)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    "data-name": "Rectangle 2336",
    rx: 1,
    transform: "translate(15 122)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 2,
    "data-name": "Rectangle 2337",
    rx: 1,
    transform: "translate(15 131)"
  }))));
};
export default SvgHamburgerIcon;